import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase/app'
import 'firebase/auth'
import './assets/styles/app.scss'
import VueClipboard from 'vue-clipboard2'
import Vuex from 'vuex'
import store from '@/store'

Vue.config.productionTip = false

let app
let config = {
  apiKey: "AIzaSyD94XA4hYe4-Sz7CmgsU47Z2ow0DcY4Thk",
  authDomain: "silicon-chandelier.firebaseapp.com",
  databaseURL: "https://silicon-chandelier.firebaseio.com",
  projectId: "silicon-chandelier",
  storageBucket: "silicon-chandelier.appspot.com",
  messagingSenderId: "374090441112"
};

Vue.use(VueClipboard)
Vue.use(Vuex)

firebase.initializeApp(config)
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>'
    })
  }
});



// WEBPACK FOOTER //
// ./src/main.js